import { render, staticRenderFns } from "./RequestCardMobile.vue?vue&type=template&id=1983c22c&lang=pug"
import script from "./RequestCardMobile.vue?vue&type=script&lang=js"
export * from "./RequestCardMobile.vue?vue&type=script&lang=js"
import style0 from "./RequestCardMobile.vue?vue&type=style&index=0&id=1983c22c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports